export const sportClubBoardTypeModel = (data = {}) => ({
    uuid: data.uuid,
    name: data.name || '',
    isActive: Number(data.is_active),
    createdAt: data.created_at || null,
    createdBy: data.created_by || null,
    updatedAt: data.updated_at || null,
    updatedBy: data.updated_by || null,
    deletedAt: data.deleted_at || null,
    deletedBy: data.deleted_by || null,
    sportClubBoards: data.sport_club_board || [],
});
